import { render } from "./AiSuggestionBubble.vue?vue&type=template&id=9bcd6c74&scoped=true"
import script from "./AiSuggestionBubble.vue?vue&type=script&lang=js"
export * from "./AiSuggestionBubble.vue?vue&type=script&lang=js"

import "./AiSuggestionBubble.vue?vue&type=style&index=0&id=9bcd6c74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bcd6c74"]])

export default __exports__